import React from "react";
import { cn } from "../../../../utils";

interface SkeletonCardEventProps {
  className?: string;
}

const SkeletonCardEvent: React.FC<SkeletonCardEventProps> = ({ className }) => {
  return (
    <div
      className={cn("w-full p-0", className)}
      data-testid="skeleton-card-event"
    >
      <div className="flex w-full flex-col gap-1">
        {/* Image skeleton */}
        <div className="relative h-[120px] w-full overflow-hidden rounded-xl">
          <div className="size-full animate-pulse bg-gray-200" />
          {/* Date placeholder */}
          <div className="absolute left-2 top-2 z-20 h-6 w-16 animate-pulse rounded-full bg-gray-300" />
        </div>

        {/* Content skeleton */}
        <div className="flex flex-col gap-1">
          {/* Event name skeleton */}
          <div className="h-6 w-3/4 animate-pulse rounded bg-gray-200" />

          {/* Subtitle skeleton */}
          <div className="h-5 w-1/2 animate-pulse rounded bg-gray-200" />

          {/* Location skeleton */}
          <div className="flex items-center gap-1">
            <div className="h-5 w-2/3 animate-pulse rounded bg-gray-200" />
          </div>

          {/* Tags skeleton */}
          <div className="flex items-center gap-2">
            <div className="h-6 w-16 animate-pulse rounded-full bg-gray-200" />
            <div className="h-6 w-14 animate-pulse rounded-full bg-gray-200" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonCardEvent;
